import { motion } from "framer-motion";
import { BarChart3 } from "lucide-react";
import { PollCard } from "@/components/PollCard";

export const ArtistPollsTab = ({ polls, handleVotePoll }) => {
  return (
    <motion.div
      key="polls"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      className="space-y-4"
    >
      {polls.length === 0 ? (
        <div className="text-center py-12">
          <BarChart3 className="w-10 h-10 text-muted-foreground mx-auto mb-3" />
          <p className="text-sm text-muted-foreground">Aucun sondage</p>
        </div>
      ) : (
        polls.map((p, i) => (
          <motion.div
            key={p.id}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.05 }}
          >
            <PollCard poll={p} onVote={handleVotePoll} />
          </motion.div>
        ))
      )}
    </motion.div>
  );
};
